import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { IconStyle } from '@website-builder/widgets/icon/model/icon-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class IconWidget extends BaseWidget<IconStyle> {
  readonly type = BuilderElementType.Icon;
  content = 'mdi:home';
  link = new TbLink();
  size = 'tb-icon-medium';
  style: IconStyle = new IconStyle();
  name = '';

  static normalizeInPlace(widget: IconWidget): IconWidget {
    const pureWidget = new IconWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.content = widget.content ?? pureWidget.content;
    widget.link = TbLink.normalizeInPlace(widget.link ?? pureWidget.link);
    widget.size = widget.size ?? pureWidget.size;
    widget.name = widget.name ?? pureWidget.name;

    widget.style = IconStyle.normalize(widget.style);

    return widget;
  }
}
